import React from "react";
import { t } from "../../../../../utils/i18n";

const TradeStatus = ({
  isDisputed,
  tradeData,
  isSystemCancelled,
}) => {
  const getTradeHeading = () => {
    
    if (tradeData.external_status === "payment_accepted") {
      return t("p2p.trade_status.accepted");
    } else if (isDisputed) {
      return t("p2p.trade_status.disputed");
    } else if (tradeData.external_status === "completed") {
      return t("p2p.trade_status.completed");
    } else if (tradeData.external_status === "cancelled" && !isSystemCancelled && tradeData.status !== "expired") {
      return t("p2p.trade_status.cancelled");
    } else if (isSystemCancelled || tradeData.status === "expired") {
      return t("p2p.trade_status.expired");
    } else if (tradeData.external_status === "payment_paid") {
      return t("p2p.trade_status.paid");
    } else if (tradeData.external_status === "pending_payment") {
      return t("p2p.trade_status.started");
    }
  };

  // Function to get dynamic class based on trade status
  const getTradeStatusClass = () => {
    if (tradeData.external_status === "payment_paid"  || tradeData.external_status === "payment_accepted" || tradeData.external_status === "completed") {
      return "tradestatus-paid";
    } else if (isDisputed) {
      return "tradestatus-disputed";
    } else if ((tradeData.external_status === "cancelled" || isSystemCancelled) && isSystemCancelled) {
      return "tradestatus-expired";
    }
    else if ((tradeData.external_status === "cancelled" || isSystemCancelled) && !isSystemCancelled) {
      return "tradestatus-cancelled";
    } else if (tradeData.external_status === "pending_payment") {
      return "tradestatus-started";
    } else {
      return "tradestatus-default"; // Default class if no condition is met
    }
  };

  return (
    <div className="tadestatus-cont">
      <div className={`tradestatus-indicator ${getTradeStatusClass()}`}>

      </div>
      <span className="tradestatus-info">
        {getTradeHeading()}
      </span>
    </div>
  );
};

export default TradeStatus;
